import ForumPage from 'components/pages/Forum';

import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getStoresList } from 'services/store';
import { getThreadCategoriesList, getThreadsList } from 'services/thread';

import APP from 'constants/app';
import FORUM from 'constants/forum';
import LINKS from 'constants/links';

const Forum = (props) => <ForumPage {...props} />;

export const getServerSideProps = async () => {
  try {
    const [
      threadsCategories,
      serverThreads,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getThreadCategoriesList(),
      getThreadsList({ limit: FORUM.THREADS_LIMIT }),
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    return {
      props: {
        category: FORUM.RECENT_THREADS_METADATA,
        gaEventCategory: FORUM.HOME_PAGE_GA_EVENT_CATEGORY,
        serverThreads,
        threadsCategories,
        threadsPage: 1,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default Forum;
